import { FC, useCallback } from 'react'
import { ProductoInterno } from '../../../../types/responses-novedades'
import { Box, Typography } from '@mui/material'
import NovedadImage from './NovedadImage'
import { mostrarFechaCompleta } from '../../../../../../utils/DateFunctions'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import ButtonRounded from '../../../../../../components/Common/utils/button/ButtonRounded'
import { NovedadControl, NovedadControlEnum } from './novedad-types'

interface Props {
  producto: ProductoInterno
  setControl: React.Dispatch<React.SetStateAction<NovedadControl>>
}

const NovedadHeader: FC<Props> = ({ producto, setControl }) => {
  const handleAplicarCambios = useCallback(() => {
    setControl({
      descripcion: NovedadControlEnum.Aplicar,
      nombre: NovedadControlEnum.Aplicar,
      precio: NovedadControlEnum.Aplicar,
      fotos: NovedadControlEnum.Aplicar
    })
  }, [])

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      gap={{ xs: '20px', md: '0px' }}
      alignItems="center"
      width="100%"
    >
      <Box display="flex" gap="19px">
        <Box>
          <NovedadImage producto={producto} />
        </Box>
        <Box display="flex" flexDirection="column" gap="6px">
          <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
            {producto.nombre}
          </Typography>
          <Box display="flex" alignItems="center">
            <Box display="flex" gap="2px">
              <Typography
                fontSize={{ xs: 12, md: 14 }}
                display="flex"
                alignItems="center"
                gap="4px"
                fontWeight="medium"
                color="#555555"
              >
                <CalendarMonthOutlinedIcon sx={{ color: 'black', fontSize: 20, fontWeight: 900 }} /> Fecha de última
                publicación:
              </Typography>
              <Typography fontSize={{ xs: 12, md: 14 }} fontWeight="medium" color="#1C1C1C">
                {mostrarFechaCompleta(producto.fechaPublicacionString, true, true)}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" gap="8px" alignItems="center">
            <Typography
              fontSize={{ xs: 12, md: 14 }}
              display="flex"
              alignItems="center"
              gap="4px"
              fontWeight="medium"
              color="#555555"
            >
              <QrCodeScannerIcon sx={{ color: 'black', fontSize: 20, fontWeight: 900 }} /> SKU:
            </Typography>
            <Typography fontSize={{ xs: 12, md: 14 }} fontWeight="medium" color="#1C1C1C">
              {producto.sku}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box alignSelf={{ xs: 'flex-end', md: 'center' }}>
        <ButtonRounded onClick={handleAplicarCambios} fullWidth variant="outlined">
          APLICAR TODOS LOS CAMBIOS
        </ButtonRounded>
      </Box>
    </Box>
  )
}

export default NovedadHeader
